import type React from 'react';
import styled from 'styled-components';

const CompilationContainerWrapper = styled.div`
  padding-top: 24px;
  padding-bottom: 24px;
  padding-top: 0;
`;

export interface CompilationContainerProps
  extends React.HTMLAttributes<HTMLDivElement> {}

/**
 * Container per la visualizzazione  di compilazione
 */
export function CompilationContainer(props: CompilationContainerProps) {
  return <CompilationContainerWrapper {...props} />;
}
